import { render } from "./EmailBranding.vue?vue&type=template&id=72d5921d&scoped=true&ts=true"
import script from "./EmailBranding.vue?vue&type=script&lang=ts"
export * from "./EmailBranding.vue?vue&type=script&lang=ts"

import "./EmailBranding.vue?vue&type=style&index=0&id=72d5921d&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d5921d"]])

export default __exports__